// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as OrderDetailsMapRepoConfig from "./OrderDetailsMapRepoConfig.bs.js";

var dummyResponseSample = {"pickup_loc":{"latlng":{"lat":25.20507553958164,"lng":55.270503871142864},"address":"Al Safa St - Dubai - United Arab Emirates, "},"drop_loc":{"latlng":{"lat":25.2224556,"lng":55.28191570000001},"address":"Grosvenor Tower, Sheikh Zayed Road - Dubai - United Arab Emirates"},"accepted_loc":{
          "lat": 13.1,
          "lng": 77.51005,
        },"trip_started_loc":{"latlng":{"lat":25.21037373,"lng":55.26720695},"address":"237 22 D St - Al Satwa - Dubai - United Arab Emirates"},"trip_ended_loc":{"latlng":{"lat":25.21124176,"lng":55.27272563},"address":"113 308th Rd - Al Satwa - Dubai - United Arab Emirates"},"vehicle_icon_type":"2_WHEELER","pickup_at":1657086543,"accepted_at":1657085956,"trip_started_at":1657086097,"trip_ended_at":1657087252,"waypoints":[
          {
            "latlng": {
              "lat": 28.7068,
              "lng": 77.27597000000002,
            },
            "address": "Bangalore, India"
          },
          {
            "latlng": {
            "lat": 28.70726,
            "lng": 77.27631000000002
            },
            "address": "Bangalore, India"
          },
          {
            "latlng": {
              "lat":28.70817,
              "lng":77.27661000000002
            },
            "address": "Bangalore, India"
          },
        ],"route":[{"latlng":{"lat":25.20507421,"lng":55.27050449},"ts":1657085959},{"latlng":{"lat":25.20507421,"lng":55.27050449},"ts":1657085983},{"latlng":{"lat":25.20536418,"lng":55.26995924},"ts":1657085988},{"latlng":{"lat":25.20536418,"lng":55.26995924},"ts":1657085993},{"latlng":{"lat":25.20567107,"lng":55.26937537},"ts":1657085998},{"latlng":{"lat":25.20567107,"lng":55.26937537},"ts":1657086003},{"latlng":{"lat":25.20595397,"lng":55.26883826},"ts":1657086008},{"latlng":{"lat":25.20595397,"lng":55.26883826},"ts":1657086013},{"latlng":{"lat":25.20632297,"lng":55.26816065},"ts":1657086018},{"latlng":{"lat":25.20632297,"lng":55.26816065},"ts":1657086023},{"latlng":{"lat":25.2067572,"lng":55.26732694},"ts":1657086028},{"latlng":{"lat":25.2067572,"lng":55.26732694},"ts":1657086033},{"latlng":{"lat":25.20722391,"lng":55.26642141},"ts":1657086038},{"latlng":{"lat":25.20755166,"lng":55.26591756},"ts":1657086043},{"latlng":{"lat":25.20755166,"lng":55.26591756},"ts":1657086048},{"latlng":{"lat":25.20819188,"lng":55.26569054},"ts":1657086053},{"latlng":{"lat":25.20819188,"lng":55.26569054},"ts":1657086058},{"latlng":{"lat":25.20869387,"lng":55.26603331},"ts":1657086063},{"latlng":{"lat":25.20869387,"lng":55.26603331},"ts":1657086068},{"latlng":{"lat":25.20932667,"lng":55.26646856},"ts":1657086073},{"latlng":{"lat":25.20932667,"lng":55.26646856},"ts":1657086078},{"latlng":{"lat":25.20989103,"lng":55.26684988},"ts":1657086083},{"latlng":{"lat":25.20989103,"lng":55.26684988},"ts":1657086088},{"latlng":{"lat":25.21037373,"lng":55.26720695},"ts":1657086093},{"latlng":{"lat":25.21037373,"lng":55.26720695},"ts":1657086098},{"latlng":{"lat":25.21082771,"lng":55.26754546},"ts":1657086103},{"latlng":{"lat":25.21082771,"lng":55.26754546},"ts":1657086108},{"latlng":{"lat":25.21060619,"lng":55.26804293},"ts":1657086113},{"latlng":{"lat":25.21060619,"lng":55.26804293},"ts":1657086118},{"latlng":{"lat":25.21034821,"lng":55.26852453},"ts":1657086123},{"latlng":{"lat":25.21034821,"lng":55.26852453},"ts":1657086128},{"latlng":{"lat":25.21006573,"lng":55.26904816},"ts":1657086133},{"latlng":{"lat":25.21006573,"lng":55.26904816},"ts":1657086138},{"latlng":{"lat":25.20966076,"lng":55.26979848},"ts":1657086143},{"latlng":{"lat":25.20938628,"lng":55.2703336},"ts":1657086148},{"latlng":{"lat":25.20904118,"lng":55.27099323},"ts":1657086153},{"latlng":{"lat":25.20939485,"lng":55.27150034},"ts":1657086158},{"latlng":{"lat":25.21003061,"lng":55.27193046},"ts":1657086163},{"latlng":{"lat":25.21067195,"lng":55.27235822},"ts":1657086168},{"latlng":{"lat":25.21124176,"lng":55.27272563},"ts":1657086173},{"latlng":{"lat":25.21124176,"lng":55.27272563},"ts":1657087229}],"order_status":"Completed"};

var dummyResponseSampleNew = { "pickup_loc": {
          "latlng": {
            "lat": 13.1,
            "lng": 77.5,
          },
          address: "Bangalore, India"
        },
        "drop_loc": {
          "latlng": {
            "lat": 13.1,
            "lng": 77.5015,
          },
          "address": "Bangalore, India"
        },
        "accepted_loc": {
          "lat": 13.1,
          "lng": 77.51005,
        },
        "trip_started_loc": {
          "latlng": {
            "lat": 13.1,
            "lng": 77.50345,
          },
          "address": "Bangalore, India"
        },
        "trip_ended_loc": {
          "latlng": {
            "lat": 13.1,
            "lng": 77.57809,
          },
          "address": "Bangalore, India"
        },
        "vehicle_type":"2_WHEELER",
        "pickup_at": 1589803880,
        "accepted_at": 1589803800,
        "trip_started_at": 1589803860,
        "trip_ended_at": 1589803990,
        "waypoints": [
          {
            "latlng": {
            "lat": 13.1,
            "lng": 77.50056,
            },
            "address": "Bangalore, India"
          },
          {
            "latlng": {
            "lat": 13.1,
            "lng": 77.510067,
            },
            "address": "Bangalore, India"
          }
        ],
        "route": [
          {
            "latlng": {
            "lat": 13.1,
            "lng": 77.520089,
            },
            "ts": 1589803830
          },
          {
            "latlng": {
            "lat": 13.1,
            "lng": 77.521189,
            },
            "ts": 1589803840
          },
          {
            "latlng": {
            "lat": 13.2,
            "lng": 77.540098,
            },
            "ts": 15898038550
          },
          {
            "latlng": {
            "lat": 13.2,
            "lng": 77.541098,
            },
            "ts": 15898038750
          },
          {
            "latlng": {
            "lat": 13.1,
            "lng": 77.55005,
            },
            "ts": 1589803900
          }
        ],
        "order_status": "completed"
      };

var dummyResponseSample2 = { "pickup_loc": {
        "latlng": {
            "lat":28.71117,
             "lng":77.27091
          },
          address: "Bangalore, India"
        },
        "drop_loc": {
          "latlng": {
            "lat":28.705209999999997, "lng": 77.27503000000003
          },
          "address": "Bangalore, India"
        },
        "accepted_loc": {
          "lat":28.708750000000002, "lng":77.2762,
        },
        "trip_started_loc": {
          "latlng": {
            "lat":28.708750000000002,
            "lng":77.2762
          },
          "address": "Bangalore, India"
        },
        "trip_ended_loc": {
          "latlng": {
            "lat":28.705419999999997,
            "lng":77.27511000000003
          },
          "address": "Bangalore, India"
        },
        "vehicle_type":"2_WHEELER",
        "pickup_at": 1589918722,
        "accepted_at": 1589918722,
        "trip_started_at": 1589918722,
        "trip_ended_at": 1589918722,
        "waypoints": [
          {
            "latlng": {
              "lat": 28.7068,
              "lng": 77.27597000000002,
            },
            "address": "Bangalore, India"
          },
          {
            "latlng": {
            "lat": 28.70726,
            "lng": 77.27631000000002
            },
            "address": "Bangalore, India"
          }
        ],
        "route": [
          {
            "latlng": {
              "lat":28.71117,
              "lng":77.27091
            },
            "ts": 1589918722
          },
          {
            "latlng": {
              "lat":28.71117,
              "lng":77.27091
            },
            "ts": 1589918733
          },
          {
            "latlng": {
              "lat":28.71047,
              "lng":77.27238
            },
            "ts": 1589918810
          },
          {
            "latlng": {
              "lat":28.708750000000002,
              "lng":77.2762
            },
            "ts": 1589918920
          },
          {
            "latlng": {
              "lat":28.708750000000002,
               "lng":77.2762
            },
            "ts": 1589918929
          },
          {
            "latlng": {
              "lat": 28.708750000000002,
              "lng":77.2762
            },
            "ts": 1589918931
          },
          {
            "latlng": {
              "lat":28.708710000000004,
              "lng":77.27652
            },
            "ts": 1589918934
          },
          {
            "latlng": {
              "lat":28.708710000000004,
              "lng":77.27652
            },
            "ts": 1589918936
          },
          {
            "latlng": {
              "lat":28.708570000000005,
              "lng":77.2765
            },
            "ts": 1589918938
          },
          {
            "latlng": {
              "lat":28.708310000000004,
              "lng":77.27656
            },
            "ts": 1589918941
          },
          {
            "latlng": {
              "lat":28.708200000000005,
              "lng":77.27658000000001
            },
            "ts": 1589918943
          },
          {
            "latlng": {
              "lat":28.708020000000005,
              "lng":77.27662000000001
            },
            "ts": 1589918945
          },
          {
            "latlng": {
              "lat":28.707890000000006,
              "lng":77.27664000000001
            },
            "ts": 1589918948
          },
          {
            "latlng": {
              "lat":28.707840000000004,
              "lng":77.27665000000002
            },
            "ts": 1589918950
          },
          {
            "latlng": {
              "lat": 28.707510000000003,
              "lng":77.27649000000002
            },
            "ts": 1589918952
          },
          {
            "latlng": {
              "lat": 28.70726,
              "lng": 77.27631000000002
            },
            "ts": 1589918955
          },
          {
            "latlng": {
              "lat":28.70693,
              "lng": 77.27607000000002
            },
            "ts": 1589918957
          },
          {
            "latlng": {
              "lat": 28.7068,
              "lng": 77.27597000000002
            },
            "ts": 1589918959
          },
          {
            "latlng": {
              "lat":28.70674,
              "lng":77.27593000000002
            },
            "ts": 1589918962
          },
          {
            "latlng": {
              "lat":28.7065,
              "lng":77.27574000000001
            },
            "ts": 1589918964
          },
          {
            "latlng": {
              "lat":28.706329999999998,
              "lng":77.27562000000002
            },
            "ts": 1589918966
          },
          {
            "latlng": {
              "lat":28.706239999999998,
              "lng":77.27555000000002
            },
            "ts": 1589918969
          },
          {
            "latlng": {
              "lat":28.706179999999996,
              "lng":77.27551000000003
            },
            "ts": 1589918971
          },
          {
            "latlng": {
              "lat":28.705979999999997,
              "lng":77.27539000000003
            },
            "ts": 1589918973
          },
          {
            "latlng": {
              "lat":28.705799999999996,
              "lng":77.2752900000000
            },
            "ts": 1589918976
          },
          {
            "latlng": {
              "lat":28.705659999999998,
              "lng":77.27520000000003
            },
            "ts": 1589918978
          },
          {
            "latlng": {
              "lat":28.705419999999997,
              "lng":77.27511000000003
            },
            "ts": 1589918980
          },
          {
            "latlng": {
              "lat":28.705209999999997,
              "lng": 77.27503000000003
            },
            "ts": 1589918983
          },
          {
            "latlng": {
              "lat":28.75213,
              "lng":77.13916000000017
            },
            "ts": 1589921637
          }
        ],
        "order_status": "Cancelled"
      };

var dummyResponseSample3 = { "pickup_loc":{
        "latlng":{
          "lat":19.1154908,"lng":72.8726952
        },
        "address":"Andheri East, Mumbai, Maharashtra, India"
      },
      "drop_loc":{
        "latlng":{
          "lat":19.2461644,"lng":72.8509056
        },"address":"Borivali West, Mumbai, Maharashtra, India"
      },
      "accepted_loc":{
        "lat":19.1165314,"lng":72.8872024
      },
      "trip_started_loc":{
        "latlng":{
          "lat":19.1165314,"lng":72.8872024
        },
        "address":"Borivali West, Mumbai, Maharashtra, India,Borivali West, Mumbai, Maharashtra, India"
      },
      "trip_ended_loc":{
        "latlng":{
          "lat":19.1165314,"lng":72.8872024
        },
        "address":"Borivali West, Mumbai, Maharashtra, India,Borivali West, Mumbai, Maharashtra, India"
      },
      "vehicle_type":"2_WHEELER",
      "pickup_at":1439945100,
      "accepted_at":1439945100,
      "trip_started_at":1439937226,
      "trip_ended_at":1439937246,
      "waypoints":[],
      "route":[],
      "order_status":"Completed"};

var dummyResponseSample4 = {"pickup_loc":{"latlng":{"lat":12.917805,"lng":77.6220296},"address":"Zyoin, Hosur Road, Madiwala, 1st Stage, BTM Layout 1, Bengaluru, Karnataka, India"},"drop_loc":{"latlng":{"lat":12.9834704,"lng":77.7620593},"address":"MVJ College of Engineering, Channasandra Main Road, near ITPB Whitefield, 3G Homes Crimson Layout, Kadugodi, Bengaluru, Karnataka, India"},"accepted_loc":{"lat":12.91055474,"lng":77.60619111},"trip_started_loc":{"latlng":{"lat":12.91677956,"lng":77.62104746},"address":"NA"},"vehicle_type":"2_WHEELER","trip_ended_loc":{"latlng":{"lat":12.983443,"lng":77.76201763},"address":"478/422/1, Channasandra Main Road, Manjushree Layout, Channasandra Whitefield, Bengaluru, Karnataka. 7 m from Spicy Andhra pin-560067 (India)"},"pickup_at":1597861809,"accepted_at":1597861206,"trip_started_at":1597861390,"trip_ended_at":1597863079,"waypoints":[],"route":[{"latlng":{"lat":12.910547,"lng":77.606192},"ts":1597861210},{"latlng":{"lat":12.910547,"lng":77.606192},"ts":1597861220},{"latlng":{"lat":12.911106,"lng":77.606458},"ts":1597861226},{"latlng":{"lat":12.911706,"lng":77.606409},"ts":1597861232},{"latlng":{"lat":12.912407,"lng":77.606351},"ts":1597861237},{"latlng":{"lat":12.913035,"lng":77.606282},"ts":1597861243},{"latlng":{"lat":12.913612,"lng":77.606217},"ts":1597861249},{"latlng":{"lat":12.913612,"lng":77.606217},"ts":1597861254},{"latlng":{"lat":12.913686,"lng":77.607009},"ts":1597861259},{"latlng":{"lat":12.913729,"lng":77.607499},"ts":1597861264},{"latlng":{"lat":12.913729,"lng":77.607499},"ts":1597861269},{"latlng":{"lat":12.91381,"lng":77.608387},"ts":1597861276},{"latlng":{"lat":12.91386,"lng":77.608977},"ts":1597861281},{"latlng":{"lat":12.913936,"lng":77.609592},"ts":1597861287},{"latlng":{"lat":12.914434,"lng":77.609585},"ts":1597861292},{"latlng":{"lat":12.914430000000001,"lng":77.60959000000001},"ts":1597861295},{"latlng":{"lat":12.915220000000001,"lng":77.60957},"ts":1597861298},{"latlng":{"lat":12.915590000000002,"lng":77.60958000000001},"ts":1597861301},{"latlng":{"lat":12.915590000000002,"lng":77.60958000000001},"ts":1597861304},{"latlng":{"lat":12.915600000000001,"lng":77.61005},"ts":1597861307},{"latlng":{"lat":12.915600000000001,"lng":77.61005},"ts":1597861310},{"latlng":{"lat":12.91651,"lng":77.61005},"ts":1597861312},{"latlng":{"lat":12.91651,"lng":77.61005},"ts":1597861315},{"latlng":{"lat":12.916590000000001,"lng":77.61005},"ts":1597861318},{"latlng":{"lat":12.916590000000001,"lng":77.61012000000001},"ts":1597861321},{"latlng":{"lat":12.91655,"lng":77.61240000000001},"ts":1597861324},{"latlng":{"lat":12.91652,"lng":77.61416000000001},"ts":1597861327},{"latlng":{"lat":12.91652,"lng":77.61422},"ts":1597861329},{"latlng":{"lat":12.916500000000001,"lng":77.61457},"ts":1597861332},{"latlng":{"lat":12.916440000000001,"lng":77.61522000000001},"ts":1597861335},{"latlng":{"lat":12.91633,"lng":77.61632},"ts":1597861338},{"latlng":{"lat":12.916290000000002,"lng":77.61671000000001},"ts":1597861341},{"latlng":{"lat":12.91627,"lng":77.61696},"ts":1597861344},{"latlng":{"lat":12.91627,"lng":77.61705},"ts":1597861346},{"latlng":{"lat":12.916310000000001,"lng":77.61872000000001},"ts":1597861349},{"latlng":{"lat":12.916340000000002,"lng":77.61941},"ts":1597861352},{"latlng":{"lat":12.91637,"lng":77.61964},"ts":1597861355},{"latlng":{"lat":12.916500000000001,"lng":77.62017},"ts":1597861358},{"latlng":{"lat":12.916780000000001,"lng":77.62103},"ts":1597861361},{"latlng":{"lat":12.916850000000002,"lng":77.62128000000001},"ts":1597861364},{"latlng":{"lat":12.91698,"lng":77.62167000000001},"ts":1597861366},{"latlng":{"lat":12.917040000000002,"lng":77.62186000000001},"ts":1597861369},{"latlng":{"lat":12.917040000000002,"lng":77.62186000000001},"ts":1597861372},{"latlng":{"lat":12.917180000000002,"lng":77.62219},"ts":1597861375},{"latlng":{"lat":12.917250000000001,"lng":77.62227},"ts":1597861378},{"latlng":{"lat":12.917340000000001,"lng":77.62233},"ts":1597861381},{"latlng":{"lat":12.91741,"lng":77.62236},"ts":1597861383},{"latlng":{"lat":12.917480000000001,"lng":77.62238},"ts":1597861386},{"latlng":{"lat":12.917570000000001,"lng":77.62237},"ts":1597861389},{"latlng":{"lat":12.91769,"lng":77.62233},"ts":1597861392},{"latlng":{"lat":12.91792,"lng":77.62219},"ts":1597861395},{"latlng":{"lat":12.91792,"lng":77.62219},"ts":1597861398},{"latlng":{"lat":12.917921,"lng":77.622186},"ts":1597861400},{"latlng":{"lat":12.917921,"lng":77.622186},"ts":1597861432},{"latlng":{"lat":12.917247,"lng":77.622449},"ts":1597861446},{"latlng":{"lat":12.917250000000001,"lng":77.62245},"ts":1597861449},{"latlng":{"lat":12.917290000000001,"lng":77.62257000000001},"ts":1597861453},{"latlng":{"lat":12.917290000000001,"lng":77.62257000000001},"ts":1597861457},{"latlng":{"lat":12.917330000000002,"lng":77.62282},"ts":1597861460},{"latlng":{"lat":12.917330000000002,"lng":77.62286},"ts":1597861464},{"latlng":{"lat":12.917340000000001,"lng":77.62289000000001},"ts":1597861468},{"latlng":{"lat":12.917340000000001,"lng":77.62289000000001},"ts":1597861471},{"latlng":{"lat":12.917390000000001,"lng":77.62291},"ts":1597861475},{"latlng":{"lat":12.917560000000002,"lng":77.62363},"ts":1597861479},{"latlng":{"lat":12.91768,"lng":77.62438},"ts":1597861482},{"latlng":{"lat":12.917710000000001,"lng":77.62474},"ts":1597861486},{"latlng":{"lat":12.917710000000001,"lng":77.62502},"ts":1597861490},{"latlng":{"lat":12.917710000000001,"lng":77.62546},"ts":1597861494},{"latlng":{"lat":12.91768,"lng":77.62573},"ts":1597861497},{"latlng":{"lat":12.917620000000001,"lng":77.62596},"ts":1597861501},{"latlng":{"lat":12.91689,"lng":77.62840000000001},"ts":1597861505},{"latlng":{"lat":12.916850000000002,"lng":77.6286},"ts":1597861508},{"latlng":{"lat":12.916830000000001,"lng":77.62882},"ts":1597861512},{"latlng":{"lat":12.9168,"lng":77.62925000000001},"ts":1597861516},{"latlng":{"lat":12.916770000000001,"lng":77.6299},"ts":1597861519},{"latlng":{"lat":12.916710000000002,"lng":77.63107000000001},"ts":1597861523},{"latlng":{"lat":12.916580000000002,"lng":77.63231},"ts":1597861527},{"latlng":{"lat":12.916480000000002,"lng":77.63322000000001},"ts":1597861530},{"latlng":{"lat":12.91646,"lng":77.63346},"ts":1597861534},{"latlng":{"lat":12.916450000000001,"lng":77.63364},"ts":1597861538},{"latlng":{"lat":12.916360000000001,"lng":77.63475000000001},"ts":1597861541},{"latlng":{"lat":12.916350000000001,"lng":77.63493000000001},"ts":1597861545},{"latlng":{"lat":12.916350000000001,"lng":77.63493000000001},"ts":1597861549},{"latlng":{"lat":12.916290000000002,"lng":77.63521},"ts":1597861552},{"latlng":{"lat":12.916260000000001,"lng":77.63551000000001},"ts":1597861556},{"latlng":{"lat":12.915970000000002,"lng":77.63788000000001},"ts":1597861560},{"latlng":{"lat":12.915970000000002,"lng":77.63808},"ts":1597861563},{"latlng":{"lat":12.915970000000002,"lng":77.63808},"ts":1597861567},{"latlng":{"lat":12.915968,"lng":77.638077},"ts":1597861571},{"latlng":{"lat":12.915968,"lng":77.638077},"ts":1597861684},{"latlng":{"lat":12.916214,"lng":77.638963},"ts":1597861720},{"latlng":{"lat":12.916398,"lng":77.639467},"ts":1597861726},{"latlng":{"lat":12.916672,"lng":77.640002},"ts":1597861731},{"latlng":{"lat":12.916670000000002,"lng":77.64},"ts":1597861735},{"latlng":{"lat":12.9168,"lng":77.64018},"ts":1597861739},{"latlng":{"lat":12.91699,"lng":77.64039000000001},"ts":1597861743},{"latlng":{"lat":12.917100000000001,"lng":77.64052000000001},"ts":1597861748},{"latlng":{"lat":12.917300000000001,"lng":77.64077},"ts":1597861752},{"latlng":{"lat":12.917530000000001,"lng":77.64108},"ts":1597861756},{"latlng":{"lat":12.918040000000001,"lng":77.64158},"ts":1597861760},{"latlng":{"lat":12.91825,"lng":77.64179},"ts":1597861764},{"latlng":{"lat":12.91849,"lng":77.64200000000001},"ts":1597861769},{"latlng":{"lat":12.91871,"lng":77.64217000000001},"ts":1597861773},{"latlng":{"lat":12.919880000000001,"lng":77.64303000000001},"ts":1597861777},{"latlng":{"lat":12.921840000000001,"lng":77.64466},"ts":1597861781},{"latlng":{"lat":12.921990000000001,"lng":77.64479},"ts":1597861785},{"latlng":{"lat":12.9221,"lng":77.64493},"ts":1597861790},{"latlng":{"lat":12.923210000000001,"lng":77.64615},"ts":1597861794},{"latlng":{"lat":12.923420000000002,"lng":77.64639000000001},"ts":1597861798},{"latlng":{"lat":12.92365,"lng":77.64666000000001},"ts":1597861802},{"latlng":{"lat":12.923890000000002,"lng":77.64703},"ts":1597861806},{"latlng":{"lat":12.924090000000001,"lng":77.64742000000001},"ts":1597861811},{"latlng":{"lat":12.924140000000001,"lng":77.64756000000001},"ts":1597861815},{"latlng":{"lat":12.924230000000001,"lng":77.64778000000001},"ts":1597861819},{"latlng":{"lat":12.92431,"lng":77.64798},"ts":1597861823},{"latlng":{"lat":12.92435,"lng":77.64818000000001},"ts":1597861827},{"latlng":{"lat":12.9244,"lng":77.64843},"ts":1597861832},{"latlng":{"lat":12.92444,"lng":77.64874},"ts":1597861836},{"latlng":{"lat":12.92454,"lng":77.64998},"ts":1597861840},{"latlng":{"lat":12.924550000000002,"lng":77.65025},"ts":1597861844},{"latlng":{"lat":12.92454,"lng":77.65047000000001},"ts":1597861848},{"latlng":{"lat":12.924520000000001,"lng":77.65071},"ts":1597861853},{"latlng":{"lat":12.924500000000002,"lng":77.65090000000001},"ts":1597861857},{"latlng":{"lat":12.9243,"lng":77.652},"ts":1597861861},{"latlng":{"lat":12.92407,"lng":77.65310000000001},"ts":1597861865},{"latlng":{"lat":12.923850000000002,"lng":77.65415},"ts":1597861869},{"latlng":{"lat":12.92374,"lng":77.65465},"ts":1597861874},{"latlng":{"lat":12.92374,"lng":77.65465},"ts":1597861878},{"latlng":{"lat":12.92359,"lng":77.65543000000001},"ts":1597861882},{"latlng":{"lat":12.9235,"lng":77.65575000000001},"ts":1597861886},{"latlng":{"lat":12.923100000000002,"lng":77.65697},"ts":1597861890},{"latlng":{"lat":12.922120000000001,"lng":77.65974},"ts":1597861895},{"latlng":{"lat":12.922030000000001,"lng":77.66000000000001},"ts":1597861899},{"latlng":{"lat":12.92195,"lng":77.66024},"ts":1597861903},{"latlng":{"lat":12.92144,"lng":77.66227},"ts":1597861907},{"latlng":{"lat":12.921280000000001,"lng":77.66291000000001},"ts":1597861911},{"latlng":{"lat":12.921190000000001,"lng":77.66325},"ts":1597861916},{"latlng":{"lat":12.921190000000001,"lng":77.66325},"ts":1597861920},{"latlng":{"lat":12.92111,"lng":77.66364},"ts":1597861924},{"latlng":{"lat":12.92092,"lng":77.66431},"ts":1597861928},{"latlng":{"lat":12.920840000000002,"lng":77.66463},"ts":1597861932},{"latlng":{"lat":12.920810000000001,"lng":77.66474000000001},"ts":1597861937},{"latlng":{"lat":12.920800000000002,"lng":77.66485},"ts":1597861941},{"latlng":{"lat":12.92079,"lng":77.66496000000001},"ts":1597861945},{"latlng":{"lat":12.920800000000002,"lng":77.66507},"ts":1597861949},{"latlng":{"lat":12.920810000000001,"lng":77.66519000000001},"ts":1597861953},{"latlng":{"lat":12.920850000000002,"lng":77.66534},"ts":1597861958},{"latlng":{"lat":12.92087,"lng":77.66539},"ts":1597861962},{"latlng":{"lat":12.92093,"lng":77.66555000000001},"ts":1597861966},{"latlng":{"lat":12.92106,"lng":77.66589},"ts":1597861970},{"latlng":{"lat":12.921120000000002,"lng":77.66601},"ts":1597861974},{"latlng":{"lat":12.92121,"lng":77.66626000000001},"ts":1597861979},{"latlng":{"lat":12.92205,"lng":77.66805000000001},"ts":1597861983},{"latlng":{"lat":12.92317,"lng":77.67036},"ts":1597861987},{"latlng":{"lat":12.92458,"lng":77.67351000000001},"ts":1597861991},{"latlng":{"lat":12.92472,"lng":77.67383000000001},"ts":1597861995},{"latlng":{"lat":12.92486,"lng":77.67411000000001},"ts":1597862000},{"latlng":{"lat":12.92495,"lng":77.67428000000001},"ts":1597862004},{"latlng":{"lat":12.92519,"lng":77.67475},"ts":1597862008},{"latlng":{"lat":12.92562,"lng":77.67561},"ts":1597862012},{"latlng":{"lat":12.925980000000001,"lng":77.67632},"ts":1597862016},{"latlng":{"lat":12.926340000000001,"lng":77.67706000000001},"ts":1597862021},{"latlng":{"lat":12.926440000000001,"lng":77.67727000000001},"ts":1597862025},{"latlng":{"lat":12.926440000000001,"lng":77.67727000000001},"ts":1597862029},{"latlng":{"lat":12.926439,"lng":77.677266},"ts":1597862033},{"latlng":{"lat":12.926439,"lng":77.677266},"ts":1597862034},{"latlng":{"lat":12.926724,"lng":77.677863},"ts":1597862039},{"latlng":{"lat":12.927356,"lng":77.679198},"ts":1597862051},{"latlng":{"lat":12.927605,"lng":77.67973},"ts":1597862057},{"latlng":{"lat":12.927886,"lng":77.68032},"ts":1597862063},{"latlng":{"lat":12.928119,"lng":77.680811},"ts":1597862069},{"latlng":{"lat":12.928358,"lng":77.681315},"ts":1597862074},{"latlng":{"lat":12.928643,"lng":77.681936},"ts":1597862080},{"latlng":{"lat":12.92888,"lng":77.682425},"ts":1597862085},{"latlng":{"lat":12.929109,"lng":77.682896},"ts":1597862090},{"latlng":{"lat":12.929109,"lng":77.682896},"ts":1597862094},{"latlng":{"lat":12.929531,"lng":77.68377},"ts":1597862099},{"latlng":{"lat":12.929755,"lng":77.684241},"ts":1597862104},{"latlng":{"lat":12.92997,"lng":77.684673},"ts":1597862109},{"latlng":{"lat":12.930298,"lng":77.685226},"ts":1597862115},{"latlng":{"lat":12.932104,"lng":77.687346},"ts":1597862137},{"latlng":{"lat":12.932515,"lng":77.687822},"ts":1597862142},{"latlng":{"lat":12.932889,"lng":77.688245},"ts":1597862147},{"latlng":{"lat":12.933251,"lng":77.68864},"ts":1597862153},{"latlng":{"lat":12.934205,"lng":77.689681},"ts":1597862168},{"latlng":{"lat":12.934205,"lng":77.689681},"ts":1597862173},{"latlng":{"lat":12.934918,"lng":77.690455},"ts":1597862178},{"latlng":{"lat":12.934920000000002,"lng":77.69046},"ts":1597862183},{"latlng":{"lat":12.93543,"lng":77.69101},"ts":1597862187},{"latlng":{"lat":12.93552,"lng":77.69111000000001},"ts":1597862191},{"latlng":{"lat":12.93673,"lng":77.69242000000001},"ts":1597862195},{"latlng":{"lat":12.937460000000002,"lng":77.69318000000001},"ts":1597862200},{"latlng":{"lat":12.938600000000001,"lng":77.69438000000001},"ts":1597862204},{"latlng":{"lat":12.938870000000001,"lng":77.69464},"ts":1597862208},{"latlng":{"lat":12.939150000000001,"lng":77.69489},"ts":1597862212},{"latlng":{"lat":12.93932,"lng":77.69502},"ts":1597862217},{"latlng":{"lat":12.939470000000002,"lng":77.69512},"ts":1597862221},{"latlng":{"lat":12.939480000000001,"lng":77.69513},"ts":1597862225},{"latlng":{"lat":12.939680000000001,"lng":77.69526},"ts":1597862229},{"latlng":{"lat":12.941250000000002,"lng":77.69626000000001},"ts":1597862233},{"latlng":{"lat":12.941270000000001,"lng":77.69627000000001},"ts":1597862238},{"latlng":{"lat":12.942020000000001,"lng":77.69672000000001},"ts":1597862242},{"latlng":{"lat":12.942720000000001,"lng":77.69712000000001},"ts":1597862246},{"latlng":{"lat":12.94292,"lng":77.69724000000001},"ts":1597862250},{"latlng":{"lat":12.94316,"lng":77.69736},"ts":1597862255},{"latlng":{"lat":12.94344,"lng":77.69748000000001},"ts":1597862259},{"latlng":{"lat":12.94386,"lng":77.69763},"ts":1597862263},{"latlng":{"lat":12.944550000000001,"lng":77.69787000000001},"ts":1597862267},{"latlng":{"lat":12.9449,"lng":77.69800000000001},"ts":1597862272},{"latlng":{"lat":12.94561,"lng":77.69824000000001},"ts":1597862276},{"latlng":{"lat":12.94561,"lng":77.69824000000001},"ts":1597862280},{"latlng":{"lat":12.945605,"lng":77.698243},"ts":1597862284},{"latlng":{"lat":12.945605,"lng":77.698243},"ts":1597862289},{"latlng":{"lat":12.946448,"lng":77.698533},"ts":1597862295},{"latlng":{"lat":12.947091,"lng":77.698752},"ts":1597862301},{"latlng":{"lat":12.947090000000001,"lng":77.69875},"ts":1597862303},{"latlng":{"lat":12.947510000000001,"lng":77.69889},"ts":1597862305},{"latlng":{"lat":12.947840000000001,"lng":77.69899000000001},"ts":1597862306},{"latlng":{"lat":12.947840000000001,"lng":77.69899000000001},"ts":1597862308},{"latlng":{"lat":12.947870000000002,"lng":77.69889},"ts":1597862310},{"latlng":{"lat":12.947870000000002,"lng":77.69889},"ts":1597862311},{"latlng":{"lat":12.94804,"lng":77.69894000000001},"ts":1597862313},{"latlng":{"lat":12.948290000000002,"lng":77.69900000000001},"ts":1597862315},{"latlng":{"lat":12.948340000000002,"lng":77.69901},"ts":1597862316},{"latlng":{"lat":12.948340000000002,"lng":77.69901},"ts":1597862318},{"latlng":{"lat":12.94885,"lng":77.69912000000001},"ts":1597862319},{"latlng":{"lat":12.949110000000001,"lng":77.69918000000001},"ts":1597862321},{"latlng":{"lat":12.949190000000002,"lng":77.69919},"ts":1597862323},{"latlng":{"lat":12.94936,"lng":77.69923},"ts":1597862324},{"latlng":{"lat":12.949980000000002,"lng":77.69934},"ts":1597862326},{"latlng":{"lat":12.949980000000002,"lng":77.69934},"ts":1597862328},{"latlng":{"lat":12.949978,"lng":77.699344},"ts":1597862329},{"latlng":{"lat":12.949978,"lng":77.699344},"ts":1597862334},{"latlng":{"lat":12.949980000000002,"lng":77.69934},"ts":1597862337},{"latlng":{"lat":12.950610000000001,"lng":77.69946},"ts":1597862339},{"latlng":{"lat":12.9509,"lng":77.6995},"ts":1597862342},{"latlng":{"lat":12.951270000000001,"lng":77.69953000000001},"ts":1597862345},{"latlng":{"lat":12.951550000000001,"lng":77.69955},"ts":1597862348},{"latlng":{"lat":12.951780000000001,"lng":77.69961},"ts":1597862351},{"latlng":{"lat":12.951880000000001,"lng":77.69964},"ts":1597862354},{"latlng":{"lat":12.952000000000002,"lng":77.69967000000001},"ts":1597862357},{"latlng":{"lat":12.953140000000001,"lng":77.69996},"ts":1597862360},{"latlng":{"lat":12.95348,"lng":77.70004},"ts":1597862363},{"latlng":{"lat":12.954640000000001,"lng":77.70034000000001},"ts":1597862365},{"latlng":{"lat":12.954640000000001,"lng":77.70034000000001},"ts":1597862368},{"latlng":{"lat":12.954635,"lng":77.700338},"ts":1597862371},{"latlng":{"lat":12.954635,"lng":77.700338},"ts":1597862376},{"latlng":{"lat":12.955383,"lng":77.700542},"ts":1597862381},{"latlng":{"lat":12.955901,"lng":77.700702},"ts":1597862386},{"latlng":{"lat":12.956782,"lng":77.700926},"ts":1597862394},{"latlng":{"lat":12.956945,"lng":77.700237},"ts":1597862399},{"latlng":{"lat":12.957001,"lng":77.699633},"ts":1597862404},{"latlng":{"lat":12.956998,"lng":77.698955},"ts":1597862410},{"latlng":{"lat":12.956903,"lng":77.69832},"ts":1597862415},{"latlng":{"lat":12.956903,"lng":77.69832},"ts":1597862427},{"latlng":{"lat":12.957108,"lng":77.699224},"ts":1597862433},{"latlng":{"lat":12.957086,"lng":77.69985},"ts":1597862439},{"latlng":{"lat":12.95709,"lng":77.69985000000001},"ts":1597862441},{"latlng":{"lat":12.957080000000001,"lng":77.69992},"ts":1597862442},{"latlng":{"lat":12.957040000000001,"lng":77.70038000000001},"ts":1597862444},{"latlng":{"lat":12.957,"lng":77.70085},"ts":1597862445},{"latlng":{"lat":12.956990000000001,"lng":77.70094},"ts":1597862447},{"latlng":{"lat":12.956990000000001,"lng":77.70101000000001},"ts":1597862448},{"latlng":{"lat":12.956970000000002,"lng":77.70128000000001},"ts":1597862449},{"latlng":{"lat":12.95695,"lng":77.70164000000001},"ts":1597862451},{"latlng":{"lat":12.956940000000001,"lng":77.70172000000001},"ts":1597862452},{"latlng":{"lat":12.956930000000002,"lng":77.70181000000001},"ts":1597862454},{"latlng":{"lat":12.95692,"lng":77.70192},"ts":1597862455},{"latlng":{"lat":12.95692,"lng":77.70195000000001},"ts":1597862457},{"latlng":{"lat":12.95692,"lng":77.70197},"ts":1597862458},{"latlng":{"lat":12.956890000000001,"lng":77.70240000000001},"ts":1597862460},{"latlng":{"lat":12.95686,"lng":77.70280000000001},"ts":1597862461},{"latlng":{"lat":12.956840000000001,"lng":77.70303000000001},"ts":1597862462},{"latlng":{"lat":12.956840000000001,"lng":77.70303000000001},"ts":1597862464},{"latlng":{"lat":12.956837,"lng":77.703028},"ts":1597862465},{"latlng":{"lat":12.956837,"lng":77.703028},"ts":1597862470},{"latlng":{"lat":12.956775,"lng":77.703987},"ts":1597862476},{"latlng":{"lat":12.956775,"lng":77.703987},"ts":1597862481},{"latlng":{"lat":12.956727,"lng":77.704754},"ts":1597862486},{"latlng":{"lat":12.956727,"lng":77.704754},"ts":1597862491},{"latlng":{"lat":12.956646,"lng":77.705854},"ts":1597862497},{"latlng":{"lat":12.956650000000002,"lng":77.70585000000001},"ts":1597862501},{"latlng":{"lat":12.956430000000001,"lng":77.70877},"ts":1597862505},{"latlng":{"lat":12.956420000000001,"lng":77.70901},"ts":1597862508},{"latlng":{"lat":12.95639,"lng":77.70921000000001},"ts":1597862512},{"latlng":{"lat":12.956360000000002,"lng":77.70956000000001},"ts":1597862516},{"latlng":{"lat":12.956330000000001,"lng":77.7098},"ts":1597862519},{"latlng":{"lat":12.956320000000002,"lng":77.70997000000001},"ts":1597862523},{"latlng":{"lat":12.956320000000002,"lng":77.70997000000001},"ts":1597862527},{"latlng":{"lat":12.956315,"lng":77.709969},"ts":1597862530},{"latlng":{"lat":12.95625,"lng":77.710597},"ts":1597862535},{"latlng":{"lat":12.956189,"lng":77.711198},"ts":1597862540},{"latlng":{"lat":12.956155,"lng":77.711686},"ts":1597862545},{"latlng":{"lat":12.956155,"lng":77.711686},"ts":1597862551},{"latlng":{"lat":12.956088,"lng":77.712713},"ts":1597862556},{"latlng":{"lat":12.956053,"lng":77.713239},"ts":1597862562},{"latlng":{"lat":12.956005,"lng":77.713764},"ts":1597862567},{"latlng":{"lat":12.955963,"lng":77.714513},"ts":1597862573},{"latlng":{"lat":12.955963,"lng":77.714513},"ts":1597862574},{"latlng":{"lat":12.955832,"lng":77.716137},"ts":1597862590},{"latlng":{"lat":12.955805,"lng":77.716604},"ts":1597862596},{"latlng":{"lat":12.955810000000001,"lng":77.7166},"ts":1597862599},{"latlng":{"lat":12.955800000000002,"lng":77.71672000000001},"ts":1597862603},{"latlng":{"lat":12.95578,"lng":77.71727000000001},"ts":1597862606},{"latlng":{"lat":12.95578,"lng":77.71736},"ts":1597862610},{"latlng":{"lat":12.95578,"lng":77.71795},"ts":1597862613},{"latlng":{"lat":12.95579,"lng":77.71815000000001},"ts":1597862617},{"latlng":{"lat":12.95579,"lng":77.71846000000001},"ts":1597862620},{"latlng":{"lat":12.955810000000001,"lng":77.71949000000001},"ts":1597862624},{"latlng":{"lat":12.955820000000001,"lng":77.71999000000001},"ts":1597862627},{"latlng":{"lat":12.95583,"lng":77.72018000000001},"ts":1597862631},{"latlng":{"lat":12.95583,"lng":77.72092},"ts":1597862634},{"latlng":{"lat":12.95583,"lng":77.72101},"ts":1597862638},{"latlng":{"lat":12.95584,"lng":77.72119},"ts":1597862641},{"latlng":{"lat":12.955850000000002,"lng":77.72160000000001},"ts":1597862645},{"latlng":{"lat":12.95584,"lng":77.72184},"ts":1597862648},{"latlng":{"lat":12.955900000000002,"lng":77.72420000000001},"ts":1597862652},{"latlng":{"lat":12.955960000000001,"lng":77.72688000000001},"ts":1597862655},{"latlng":{"lat":12.955960000000001,"lng":77.72709},"ts":1597862659},{"latlng":{"lat":12.955990000000002,"lng":77.72808},"ts":1597862662},{"latlng":{"lat":12.955990000000002,"lng":77.72814000000001},"ts":1597862666},{"latlng":{"lat":12.956010000000001,"lng":77.72842},"ts":1597862669},{"latlng":{"lat":12.95602,"lng":77.72856},"ts":1597862673},{"latlng":{"lat":12.956080000000002,"lng":77.72939000000001},"ts":1597862676},{"latlng":{"lat":12.956090000000001,"lng":77.72944000000001},"ts":1597862680},{"latlng":{"lat":12.95611,"lng":77.72973},"ts":1597862683},{"latlng":{"lat":12.956140000000001,"lng":77.73014},"ts":1597862687},{"latlng":{"lat":12.956140000000001,"lng":77.73024000000001},"ts":1597862690},{"latlng":{"lat":12.956180000000002,"lng":77.73100000000001},"ts":1597862694},{"latlng":{"lat":12.956230000000001,"lng":77.73149000000001},"ts":1597862697},{"latlng":{"lat":12.95625,"lng":77.73161},"ts":1597862701},{"latlng":{"lat":12.956280000000001,"lng":77.73190000000001},"ts":1597862705},{"latlng":{"lat":12.95645,"lng":77.7329},"ts":1597862708},{"latlng":{"lat":12.95696,"lng":77.73594},"ts":1597862712},{"latlng":{"lat":12.957080000000001,"lng":77.73686000000001},"ts":1597862715},{"latlng":{"lat":12.95705,"lng":77.73822000000001},"ts":1597862719},{"latlng":{"lat":12.95705,"lng":77.73834000000001},"ts":1597862722},{"latlng":{"lat":12.95705,"lng":77.73873},"ts":1597862726},{"latlng":{"lat":12.95705,"lng":77.73883000000001},"ts":1597862729},{"latlng":{"lat":12.957030000000001,"lng":77.73951000000001},"ts":1597862733},{"latlng":{"lat":12.95701,"lng":77.73981},"ts":1597862736},{"latlng":{"lat":12.95701,"lng":77.73985},"ts":1597862740},{"latlng":{"lat":12.957020000000002,"lng":77.74065},"ts":1597862743},{"latlng":{"lat":12.95701,"lng":77.74118},"ts":1597862747},{"latlng":{"lat":12.95701,"lng":77.74125000000001},"ts":1597862750},{"latlng":{"lat":12.95701,"lng":77.74197000000001},"ts":1597862754},{"latlng":{"lat":12.95701,"lng":77.74201000000001},"ts":1597862757},{"latlng":{"lat":12.956980000000001,"lng":77.74336000000001},"ts":1597862761},{"latlng":{"lat":12.956940000000001,"lng":77.74364000000001},"ts":1597862764},{"latlng":{"lat":12.956890000000001,"lng":77.74390000000001},"ts":1597862768},{"latlng":{"lat":12.95677,"lng":77.74439000000001},"ts":1597862771},{"latlng":{"lat":12.95672,"lng":77.74457000000001},"ts":1597862775},{"latlng":{"lat":12.95672,"lng":77.74474000000001},"ts":1597862778},{"latlng":{"lat":12.95677,"lng":77.74491},"ts":1597862782},{"latlng":{"lat":12.956850000000001,"lng":77.74505},"ts":1597862785},{"latlng":{"lat":12.95696,"lng":77.74521},"ts":1597862789},{"latlng":{"lat":12.957020000000002,"lng":77.74527},"ts":1597862792},{"latlng":{"lat":12.95706,"lng":77.74532},"ts":1597862796},{"latlng":{"lat":12.95709,"lng":77.74536},"ts":1597862799},{"latlng":{"lat":12.9571,"lng":77.74537000000001},"ts":1597862803},{"latlng":{"lat":12.957350000000002,"lng":77.74565000000001},"ts":1597862806},{"latlng":{"lat":12.957350000000002,"lng":77.74565000000001},"ts":1597862810},{"latlng":{"lat":12.95738,"lng":77.74566},"ts":1597862813},{"latlng":{"lat":12.957910000000002,"lng":77.7459},"ts":1597862817},{"latlng":{"lat":12.958350000000001,"lng":77.74611},"ts":1597862820},{"latlng":{"lat":12.95861,"lng":77.74623000000001},"ts":1597862824},{"latlng":{"lat":12.958960000000001,"lng":77.74642},"ts":1597862827},{"latlng":{"lat":12.959320000000002,"lng":77.74661},"ts":1597862831},{"latlng":{"lat":12.960960000000002,"lng":77.74752000000001},"ts":1597862834},{"latlng":{"lat":12.960960000000002,"lng":77.74752000000001},"ts":1597862838},{"latlng":{"lat":12.960959,"lng":77.747517},"ts":1597862841},{"latlng":{"lat":12.960960000000002,"lng":77.74752000000001},"ts":1597862844},{"latlng":{"lat":12.961010000000002,"lng":77.74755},"ts":1597862846},{"latlng":{"lat":12.96122,"lng":77.74762000000001},"ts":1597862848},{"latlng":{"lat":12.96133,"lng":77.74761000000001},"ts":1597862851},{"latlng":{"lat":12.961450000000001,"lng":77.74761000000001},"ts":1597862853},{"latlng":{"lat":12.9616,"lng":77.74763},"ts":1597862855},{"latlng":{"lat":12.961730000000001,"lng":77.74764},"ts":1597862858},{"latlng":{"lat":12.96184,"lng":77.74766000000001},"ts":1597862860},{"latlng":{"lat":12.962530000000001,"lng":77.74788000000001},"ts":1597862863},{"latlng":{"lat":12.96301,"lng":77.74804},"ts":1597862865},{"latlng":{"lat":12.96316,"lng":77.74809},"ts":1597862867},{"latlng":{"lat":12.963510000000001,"lng":77.74821},"ts":1597862870},{"latlng":{"lat":12.963730000000002,"lng":77.74828000000001},"ts":1597862872},{"latlng":{"lat":12.96385,"lng":77.74832},"ts":1597862874},{"latlng":{"lat":12.964020000000001,"lng":77.74837000000001},"ts":1597862877},{"latlng":{"lat":12.964170000000001,"lng":77.74842000000001},"ts":1597862879},{"latlng":{"lat":12.965090000000002,"lng":77.74871},"ts":1597862881},{"latlng":{"lat":12.965390000000001,"lng":77.74881},"ts":1597862884},{"latlng":{"lat":12.966120000000002,"lng":77.74903},"ts":1597862886},{"latlng":{"lat":12.966370000000001,"lng":77.74911},"ts":1597862888},{"latlng":{"lat":12.9669,"lng":77.74926},"ts":1597862891},{"latlng":{"lat":12.96775,"lng":77.74949000000001},"ts":1597862893},{"latlng":{"lat":12.96841,"lng":77.74966},"ts":1597862895},{"latlng":{"lat":12.96845,"lng":77.74967000000001},"ts":1597862898},{"latlng":{"lat":12.968610000000002,"lng":77.7497},"ts":1597862900},{"latlng":{"lat":12.968820000000001,"lng":77.74974},"ts":1597862902},{"latlng":{"lat":12.968860000000001,"lng":77.74975},"ts":1597862905},{"latlng":{"lat":12.968990000000002,"lng":77.74977000000001},"ts":1597862907},{"latlng":{"lat":12.96901,"lng":77.74978},"ts":1597862910},{"latlng":{"lat":12.969510000000001,"lng":77.74986000000001},"ts":1597862912},{"latlng":{"lat":12.969840000000001,"lng":77.74992},"ts":1597862914},{"latlng":{"lat":12.97028,"lng":77.74996},"ts":1597862917},{"latlng":{"lat":12.9707,"lng":77.75003000000001},"ts":1597862919},{"latlng":{"lat":12.970810000000002,"lng":77.75004000000001},"ts":1597862921},{"latlng":{"lat":12.97104,"lng":77.75008000000001},"ts":1597862924},{"latlng":{"lat":12.97137,"lng":77.7501},"ts":1597862926},{"latlng":{"lat":12.97225,"lng":77.75018},"ts":1597862928},{"latlng":{"lat":12.973920000000001,"lng":77.75042},"ts":1597862931},{"latlng":{"lat":12.974810000000002,"lng":77.75057000000001},"ts":1597862933},{"latlng":{"lat":12.975060000000001,"lng":77.75061000000001},"ts":1597862935},{"latlng":{"lat":12.97512,"lng":77.75062000000001},"ts":1597862938},{"latlng":{"lat":12.97522,"lng":77.75065000000001},"ts":1597862940},{"latlng":{"lat":12.976320000000001,"lng":77.75087},"ts":1597862942},{"latlng":{"lat":12.977290000000002,"lng":77.75107000000001},"ts":1597862945},{"latlng":{"lat":12.977300000000001,"lng":77.75107000000001},"ts":1597862947},{"latlng":{"lat":12.977350000000001,"lng":77.75108},"ts":1597862949},{"latlng":{"lat":12.978330000000001,"lng":77.75129000000001},"ts":1597862952},{"latlng":{"lat":12.979500000000002,"lng":77.75151000000001},"ts":1597862954},{"latlng":{"lat":12.980070000000001,"lng":77.75163},"ts":1597862957},{"latlng":{"lat":12.98033,"lng":77.75168000000001},"ts":1597862959},{"latlng":{"lat":12.98065,"lng":77.75173000000001},"ts":1597862961},{"latlng":{"lat":12.981660000000002,"lng":77.75191000000001},"ts":1597862964},{"latlng":{"lat":12.982690000000002,"lng":77.75210000000001},"ts":1597862966},{"latlng":{"lat":12.9829,"lng":77.75214000000001},"ts":1597862968},{"latlng":{"lat":12.983010000000002,"lng":77.75217},"ts":1597862971},{"latlng":{"lat":12.983460000000001,"lng":77.75229},"ts":1597862973},{"latlng":{"lat":12.98375,"lng":77.75236000000001},"ts":1597862975},{"latlng":{"lat":12.98375,"lng":77.75236000000001},"ts":1597862978},{"latlng":{"lat":12.983820000000001,"lng":77.75240000000001},"ts":1597862980},{"latlng":{"lat":12.9838,"lng":77.75247},"ts":1597862982},{"latlng":{"lat":12.98379,"lng":77.75256},"ts":1597862985},{"latlng":{"lat":12.983730000000001,"lng":77.75315},"ts":1597862987},{"latlng":{"lat":12.983670000000002,"lng":77.75353000000001},"ts":1597862989},{"latlng":{"lat":12.983640000000001,"lng":77.75376},"ts":1597862992},{"latlng":{"lat":12.983600000000001,"lng":77.75398000000001},"ts":1597862994},{"latlng":{"lat":12.98357,"lng":77.75421},"ts":1597862996},{"latlng":{"lat":12.983530000000002,"lng":77.75442000000001},"ts":1597862999},{"latlng":{"lat":12.983460000000001,"lng":77.75464000000001},"ts":1597863001},{"latlng":{"lat":12.98324,"lng":77.75512},"ts":1597863004},{"latlng":{"lat":12.98309,"lng":77.75545000000001},"ts":1597863006},{"latlng":{"lat":12.982970000000002,"lng":77.75571000000001},"ts":1597863008},{"latlng":{"lat":12.98295,"lng":77.75579},"ts":1597863011},{"latlng":{"lat":12.982830000000002,"lng":77.7561},"ts":1597863013},{"latlng":{"lat":12.98277,"lng":77.75635000000001},"ts":1597863015},{"latlng":{"lat":12.982700000000001,"lng":77.75669},"ts":1597863018},{"latlng":{"lat":12.98263,"lng":77.75707000000001},"ts":1597863020},{"latlng":{"lat":12.982600000000001,"lng":77.75722},"ts":1597863022},{"latlng":{"lat":12.98258,"lng":77.75736},"ts":1597863025},{"latlng":{"lat":12.982510000000001,"lng":77.75778000000001},"ts":1597863027},{"latlng":{"lat":12.98249,"lng":77.75812},"ts":1597863029},{"latlng":{"lat":12.982460000000001,"lng":77.75819000000001},"ts":1597863032},{"latlng":{"lat":12.98244,"lng":77.75828000000001},"ts":1597863034},{"latlng":{"lat":12.982460000000001,"lng":77.75853000000001},"ts":1597863036},{"latlng":{"lat":12.982510000000001,"lng":77.75895000000001},"ts":1597863039},{"latlng":{"lat":12.982510000000001,"lng":77.75895000000001},"ts":1597863041},{"latlng":{"lat":12.982514,"lng":77.758948},"ts":1597863043},{"latlng":{"lat":12.9826,"lng":77.759602},"ts":1597863049},{"latlng":{"lat":12.983026,"lng":77.761914},"ts":1597863071},{"latlng":{"lat":12.983026,"lng":77.761914},"ts":1597863076}],"order_status":"Completed"};

var dummyResponseSample5 = {
          "pickup_loc": {
            "latlng": {
              "lat": 12.9163279,
              "lng": 77.6138967,
            },
            "address": "Gangothri Hospital, Outer Ring Road, Old Madiwala, Kuvempu Nagar, Stage 2, BTM Layout, Bengaluru, Karnataka, India",
          },
          "drop_loc": {
            "latlng": {
              "lat": 12.9201596,
              "lng": 77.6512411,
            },
            "address": "HSR Layout Police Station, 27th Main Road, 1st Sector, HSR Layout, Bengaluru, Karnataka, India",
          },
          "accepted_loc": {
            "lat": 12.9102482,
            "lng": 77.6053308,
          },
          "trip_started_loc": {
            "latlng": {
              "lat": 12.916269666666667,
              "lng": 77.614147,
            },
            "address": "NA",
          },
          "trip_ended_loc": {
            "latlng": {
              "lat": 12.920607,
              "lng": 77.651247,
            },
            "address": "29, 27th Main Road, Bosappa Layout, HSR Layout, Bengaluru, Karnataka. 31 m from Kalluru Infra Pvt Ltd pin-560102 (India)",
          },
          "vehicle_type":"2_WHEELER",
          "pickup_at": 1598450073,
          "accepted_at": 1598449470,
          "trip_started_at": 1598449798,
          "trip_ended_at": 1598450217,
          "waypoints": [],
          "route": [
            {
              "latlng": {
                "lat": 12.910164,
                "lng": 77.605363,
              },
              "ts": 1598449472,
            },
            {
              "latlng": {
                "lat": 12.910176,
                "lng": 77.605157,
              },
              "ts": 1598449475,
            },
            {
              "latlng": {
                "lat": 12.910176,
                "lng": 77.605157,
              },
              "ts": 1598449500,
            },
            {
              "latlng": {
                "lat": 12.910167,
                "lng": 77.605317,
              },
              "ts": 1598449510,
            },
            {
              "latlng": {
                "lat": 12.910167,
                "lng": 77.605316,
              },
              "ts": 1598449515,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.605326,
              },
              "ts": 1598449525,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.605332,
              },
              "ts": 1598449530,
            },
            {
              "latlng": {
                "lat": 12.910165,
                "lng": 77.605334,
              },
              "ts": 1598449532,
            },
            {
              "latlng": {
                "lat": 12.910165,
                "lng": 77.60534,
              },
              "ts": 1598449535,
            },
            {
              "latlng": {
                "lat": 12.910165,
                "lng": 77.605343,
              },
              "ts": 1598449540,
            },
            {
              "latlng": {
                "lat": 12.910165,
                "lng": 77.605344,
              },
              "ts": 1598449547,
            },
            {
              "latlng": {
                "lat": 12.910165,
                "lng": 77.605344,
              },
              "ts": 1598449612,
            },
            {
              "latlng": {
                "lat": 12.910162,
                "lng": 77.605392,
              },
              "ts": 1598449617,
            },
            {
              "latlng": {
                "lat": 12.910163,
                "lng": 77.605369,
              },
              "ts": 1598449622,
            },
            {
              "latlng": {
                "lat": 12.910176,
                "lng": 77.605157,
              },
              "ts": 1598449631,
            },
            {
              "latlng": {
                "lat": 12.910176,
                "lng": 77.605157,
              },
              "ts": 1598449642,
            },
            {
              "latlng": {
                "lat": 12.910145,
                "lng": 77.605672,
              },
              "ts": 1598449648,
            },
            {
              "latlng": {
                "lat": 12.910126,
                "lng": 77.606005,
              },
              "ts": 1598449654,
            },
            {
              "latlng": {
                "lat": 12.910546,
                "lng": 77.606018,
              },
              "ts": 1598449655,
            },
            {
              "latlng": {
                "lat": 12.910555,
                "lng": 77.606493,
              },
              "ts": 1598449660,
            },
            {
              "latlng": {
                "lat": 12.910948,
                "lng": 77.606471,
              },
              "ts": 1598449666,
            },
            {
              "latlng": {
                "lat": 12.911704,
                "lng": 77.606409,
              },
              "ts": 1598449671,
            },
            {
              "latlng": {
                "lat": 12.912332,
                "lng": 77.606358,
              },
              "ts": 1598449677,
            },
            {
              "latlng": {
                "lat": 12.912985,
                "lng": 77.606287,
              },
              "ts": 1598449682,
            },
            {
              "latlng": {
                "lat": 12.913644,
                "lng": 77.606539,
              },
              "ts": 1598449688,
            },
            {
              "latlng": {
                "lat": 12.91373,
                "lng": 77.607512,
              },
              "ts": 1598449693,
            },
            {
              "latlng": {
                "lat": 12.913795,
                "lng": 77.608213,
              },
              "ts": 1598449698,
            },
            {
              "latlng": {
                "lat": 12.913855,
                "lng": 77.608927,
              },
              "ts": 1598449704,
            },
            {
              "latlng": {
                "lat": 12.913931,
                "lng": 77.609768,
              },
              "ts": 1598449710,
            },
            {
              "latlng": {
                "lat": 12.914124,
                "lng": 77.610035,
              },
              "ts": 1598449715,
            },
            {
              "latlng": {
                "lat": 12.914124,
                "lng": 77.610035,
              },
              "ts": 1598449715,
            },
            {
              "latlng": {
                "lat": 12.914622,
                "lng": 77.610039,
              },
              "ts": 1598449721,
            },
            {
              "latlng": {
                "lat": 12.914997,
                "lng": 77.610043,
              },
              "ts": 1598449726,
            },
            {
              "latlng": {
                "lat": 12.915446,
                "lng": 77.610047,
              },
              "ts": 1598449732,
            },
            {
              "latlng": {
                "lat": 12.915821,
                "lng": 77.610048,
              },
              "ts": 1598449737,
            },
            {
              "latlng": {
                "lat": 12.915937,
                "lng": 77.610424,
              },
              "ts": 1598449743,
            },
            {
              "latlng": {
                "lat": 12.91593,
                "lng": 77.610877,
              },
              "ts": 1598449748,
            },
            {
              "latlng": {
                "lat": 12.915922,
                "lng": 77.611346,
              },
              "ts": 1598449753,
            },
            {
              "latlng": {
                "lat": 12.915914,
                "lng": 77.611909,
              },
              "ts": 1598449759,
            },
            {
              "latlng": {
                "lat": 12.915914,
                "lng": 77.612438,
              },
              "ts": 1598449765,
            },
            {
              "latlng": {
                "lat": 12.915931,
                "lng": 77.613114,
              },
              "ts": 1598449771,
            },
            {
              "latlng": {
                "lat": 12.91592,
                "lng": 77.613798,
              },
              "ts": 1598449775,
            },
            {
              "latlng": {
                "lat": 12.915984,
                "lng": 77.614413,
              },
              "ts": 1598449781,
            },
            {
              "latlng": {
                "lat": 12.916439,
                "lng": 77.614321,
              },
              "ts": 1598449786,
            },
            {
              "latlng": {
                "lat": 12.916448,
                "lng": 77.613893,
              },
              "ts": 1598449792,
            },
            {
              "latlng": {
                "lat": 12.916448,
                "lng": 77.613893,
              },
              "ts": 1598449796,
            },
            {
              "latlng": {
                "lat": 12.915931,
                "lng": 77.613799,
              },
              "ts": 1598449802,
            },
            {
              "latlng": {
                "lat": 12.915931,
                "lng": 77.613799,
              },
              "ts": 1598449802,
            },
            {
              "latlng": {
                "lat": 12.910393,
                "lng": 77.605367,
              },
              "ts": 1598449807,
            },
            {
              "latlng": {
                "lat": 12.910398,
                "lng": 77.605178,
              },
              "ts": 1598449812,
            },
            {
              "latlng": {
                "lat": 12.91646,
                "lng": 77.613294,
              },
              "ts": 1598449818,
            },
            {
              "latlng": {
                "lat": 12.916461,
                "lng": 77.612879,
              },
              "ts": 1598449823,
            },
            {
              "latlng": {
                "lat": 12.916458,
                "lng": 77.612494,
              },
              "ts": 1598449828,
            },
            {
              "latlng": {
                "lat": 12.916463,
                "lng": 77.612032,
              },
              "ts": 1598449833,
            },
            {
              "latlng": {
                "lat": 12.916469,
                "lng": 77.611866,
              },
              "ts": 1598449835,
            },
            {
              "latlng": {
                "lat": 12.916488,
                "lng": 77.611284,
              },
              "ts": 1598449841,
            },
            {
              "latlng": {
                "lat": 12.916501,
                "lng": 77.610672,
              },
              "ts": 1598449846,
            },
            {
              "latlng": {
                "lat": 12.916585,
                "lng": 77.610313,
              },
              "ts": 1598449851,
            },
            {
              "latlng": {
                "lat": 12.916572,
                "lng": 77.611222,
              },
              "ts": 1598449857,
            },
            {
              "latlng": {
                "lat": 12.916561,
                "lng": 77.611942,
              },
              "ts": 1598449862,
            },
            {
              "latlng": {
                "lat": 12.910392,
                "lng": 77.605402,
              },
              "ts": 1598449868,
            },
            {
              "latlng": {
                "lat": 12.916506,
                "lng": 77.61443,
              },
              "ts": 1598449883,
            },
            {
              "latlng": {
                "lat": 12.91647,
                "lng": 77.614884,
              },
              "ts": 1598449888,
            },
            {
              "latlng": {
                "lat": 12.916407,
                "lng": 77.615533,
              },
              "ts": 1598449894,
            },
            {
              "latlng": {
                "lat": 12.916397,
                "lng": 77.615631,
              },
              "ts": 1598449896,
            },
            {
              "latlng": {
                "lat": 12.916328,
                "lng": 77.616316,
              },
              "ts": 1598449901,
            },
            {
              "latlng": {
                "lat": 12.916268,
                "lng": 77.617026,
              },
              "ts": 1598449907,
            },
            {
              "latlng": {
                "lat": 12.916286,
                "lng": 77.617725,
              },
              "ts": 1598449912,
            },
            {
              "latlng": {
                "lat": 12.916303,
                "lng": 77.618391,
              },
              "ts": 1598449917,
            },
            {
              "latlng": {
                "lat": 12.916329,
                "lng": 77.619197,
              },
              "ts": 1598449923,
            },
            {
              "latlng": {
                "lat": 12.916418,
                "lng": 77.619829,
              },
              "ts": 1598449929,
            },
            {
              "latlng": {
                "lat": 12.916515,
                "lng": 77.620209,
              },
              "ts": 1598449934,
            },
            {
              "latlng": {
                "lat": 12.916655,
                "lng": 77.620653,
              },
              "ts": 1598449940,
            },
            {
              "latlng": {
                "lat": 12.916794,
                "lng": 77.621092,
              },
              "ts": 1598449946,
            },
            {
              "latlng": {
                "lat": 12.916953,
                "lng": 77.621596,
              },
              "ts": 1598449952,
            },
            {
              "latlng": {
                "lat": 12.91703,
                "lng": 77.621832,
              },
              "ts": 1598449955,
            },
            {
              "latlng": {
                "lat": 12.917224,
                "lng": 77.622383,
              },
              "ts": 1598449961,
            },
            {
              "latlng": {
                "lat": 12.917413,
                "lng": 77.622995,
              },
              "ts": 1598449967,
            },
            {
              "latlng": {
                "lat": 12.917523,
                "lng": 77.623462,
              },
              "ts": 1598449972,
            },
            {
              "latlng": {
                "lat": 12.917613,
                "lng": 77.623946,
              },
              "ts": 1598449978,
            },
            {
              "latlng": {
                "lat": 12.917676,
                "lng": 77.62434,
              },
              "ts": 1598449983,
            },
            {
              "latlng": {
                "lat": 12.917612,
                "lng": 77.624737,
              },
              "ts": 1598449988,
            },
            {
              "latlng": {
                "lat": 12.910398,
                "lng": 77.605178,
              },
              "ts": 1598449994,
            },
            {
              "latlng": {
                "lat": 12.910392,
                "lng": 77.605385,
              },
              "ts": 1598449999,
            },
            {
              "latlng": {
                "lat": 12.91747,
                "lng": 77.626465,
              },
              "ts": 1598450004,
            },
            {
              "latlng": {
                "lat": 12.917318,
                "lng": 77.626972,
              },
              "ts": 1598450009,
            },
            {
              "latlng": {
                "lat": 12.917168,
                "lng": 77.627476,
              },
              "ts": 1598450014,
            },
            {
              "latlng": {
                "lat": 12.917135,
                "lng": 77.627588,
              },
              "ts": 1598450015,
            },
            {
              "latlng": {
                "lat": 12.916887,
                "lng": 77.628421,
              },
              "ts": 1598450021,
            },
            {
              "latlng": {
                "lat": 12.916808,
                "lng": 77.629078,
              },
              "ts": 1598450026,
            },
            {
              "latlng": {
                "lat": 12.916765,
                "lng": 77.629921,
              },
              "ts": 1598450032,
            },
            {
              "latlng": {
                "lat": 12.916727,
                "lng": 77.630664,
              },
              "ts": 1598450038,
            },
            {
              "latlng": {
                "lat": 12.910392,
                "lng": 77.605384,
              },
              "ts": 1598450044,
            },
            {
              "latlng": {
                "lat": 12.910392,
                "lng": 77.605387,
              },
              "ts": 1598450049,
            },
            {
              "latlng": {
                "lat": 12.916525,
                "lng": 77.632806,
              },
              "ts": 1598450054,
            },
            {
              "latlng": {
                "lat": 12.916449,
                "lng": 77.633594,
              },
              "ts": 1598450059,
            },
            {
              "latlng": {
                "lat": 12.916391,
                "lng": 77.634326,
              },
              "ts": 1598450064,
            },
            {
              "latlng": {
                "lat": 12.916335,
                "lng": 77.635166,
              },
              "ts": 1598450070,
            },
            {
              "latlng": {
                "lat": 12.916297,
                "lng": 77.635742,
              },
              "ts": 1598450075,
            },
            {
              "latlng": {
                "lat": 12.916197,
                "lng": 77.636642,
              },
              "ts": 1598450080,
            },
            {
              "latlng": {
                "lat": 12.916077,
                "lng": 77.637573,
              },
              "ts": 1598450086,
            },
            {
              "latlng": {
                "lat": 12.916067,
                "lng": 77.638436,
              },
              "ts": 1598450091,
            },
            {
              "latlng": {
                "lat": 12.916368,
                "lng": 77.639388,
              },
              "ts": 1598450097,
            },
            {
              "latlng": {
                "lat": 12.916828,
                "lng": 77.640206,
              },
              "ts": 1598450103,
            },
            {
              "latlng": {
                "lat": 12.917232,
                "lng": 77.640688,
              },
              "ts": 1598450109,
            },
            {
              "latlng": {
                "lat": 12.917683,
                "lng": 77.641232,
              },
              "ts": 1598450114,
            },
            {
              "latlng": {
                "lat": 12.918117,
                "lng": 77.64166,
              },
              "ts": 1598450119,
            },
            {
              "latlng": {
                "lat": 12.91867,
                "lng": 77.64214,
              },
              "ts": 1598450125,
            },
            {
              "latlng": {
                "lat": 12.919128,
                "lng": 77.64248,
              },
              "ts": 1598450131,
            },
            {
              "latlng": {
                "lat": 12.919439,
                "lng": 77.642709,
              },
              "ts": 1598450135,
            },
            {
              "latlng": {
                "lat": 12.919817,
                "lng": 77.642988,
              },
              "ts": 1598450141,
            },
            {
              "latlng": {
                "lat": 12.919707,
                "lng": 77.64339,
              },
              "ts": 1598450147,
            },
            {
              "latlng": {
                "lat": 12.919659,
                "lng": 77.644018,
              },
              "ts": 1598450153,
            },
            {
              "latlng": {
                "lat": 12.919618,
                "lng": 77.644728,
              },
              "ts": 1598450159,
            },
            {
              "latlng": {
                "lat": 12.919575,
                "lng": 77.645485,
              },
              "ts": 1598450164,
            },
            {
              "latlng": {
                "lat": 12.919518,
                "lng": 77.646392,
              },
              "ts": 1598450170,
            },
            {
              "latlng": {
                "lat": 12.910393,
                "lng": 77.605371,
              },
              "ts": 1598450176,
            },
            {
              "latlng": {
                "lat": 12.910393,
                "lng": 77.605375,
              },
              "ts": 1598450181,
            },
            {
              "latlng": {
                "lat": 12.919667,
                "lng": 77.650234,
              },
              "ts": 1598450195,
            },
            {
              "latlng": {
                "lat": 12.919704,
                "lng": 77.65127,
              },
              "ts": 1598450200,
            },
            {
              "latlng": {
                "lat": 12.910392,
                "lng": 77.605396,
              },
              "ts": 1598450206,
            },
            {
              "latlng": {
                "lat": 12.920607,
                "lng": 77.651247,
              },
              "ts": 1598450212,
            },
            {
              "latlng": {
                "lat": 12.920607,
                "lng": 77.651247,
              },
              "ts": 1598450215,
            },
            {
              "latlng": {
                "lat": 12.920245,
                "lng": 77.65161,
              },
              "ts": 1598450217,
            },
            {
              "latlng": {
                "lat": 12.920246,
                "lng": 77.65161,
              },
              "ts": 1598450222,
            },
            {
              "latlng": {
                "lat": 12.920245,
                "lng": 77.65161,
              },
              "ts": 1598450227,
            },
            {
              "latlng": {
                "lat": 12.920245,
                "lng": 77.65161,
              },
              "ts": 1598450238,
            },
            {
              "latlng": {
                "lat": 12.920246,
                "lng": 77.65161,
              },
              "ts": 1598450243,
            },
            {
              "latlng": {
                "lat": 12.920245,
                "lng": 77.65161,
              },
              "ts": 1598450248,
            },
            {
              "latlng": {
                "lat": 12.920245,
                "lng": 77.65161,
              },
              "ts": 1598450271,
            },
            {
              "latlng": {
                "lat": 12.910162,
                "lng": 77.605399,
              },
              "ts": 1598450277,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.60533,
              },
              "ts": 1598450287,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.605323,
              },
              "ts": 1598450292,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.60532,
              },
              "ts": 1598450297,
            },
            {
              "latlng": {
                "lat": 12.910166,
                "lng": 77.605318,
              },
              "ts": 1598450302,
            },
          ],
          "order_status": "Accepted",
        };

var dummyResponseSample6 = {
      "pickup_loc":{
         "latlng":{
            "lat":12.935158,
            "lng":77.6135455
         },
         "address":"Kitchens@ Koramangala, Koramangala Industrial Layout, Bangalore, Bengaluru, Karnataka, India"
      },
      "drop_loc":{
         "latlng":{
            "lat":12.911877,
            "lng":77.6392329
         },
         "address":"Mad Over Donuts, 18th Cross Road, Sector 3, HSR Layout, Bengaluru, Karnataka, India"
      },
      "accepted_loc":{
         "lat":12.9370882,
         "lng":77.6246152
      },
      "trip_started_loc":{
         "latlng":{
            "lat":12.93514,
            "lng":77.612933
         },
         "address":"2, 1st A Cross Road, Block 7, Koramangala, Bengaluru, Karnataka. 11 m from Burger King pin-560095 (India)"
      },
      "trip_ended_loc":{
         "latlng":{
            "lat":12.912053,
            "lng":77.639108
         },
         "address":"1087A, 18th Cross Road, Sector 3, HSR Layout, Bengaluru, Karnataka. 12 m from Warm Oven pin-560102 (India)"
      },
      "vehicle_type":"2_WHEELER",
      "pickup_at":1620910044,
      "accepted_at":1620906475,
      "trip_started_at":1620907003,
      "trip_ended_at":1620907728,
      "waypoints":[
         
         {
          "latlng":{
             "lat":12.91796,
             "lng":77.63833000000001
          },
          "address": "Bangalore, India"
       },

      ],
      "route":[
         {
            "latlng":{
               "lat":12.937133,
               "lng":77.624568
            },
            "ts":1620906487
         },
         {
            "latlng":{
               "lat":12.937133,
               "lng":77.624568
            },
            "ts":1620906498
         },
         {
            "latlng":{
               "lat":12.937731,
               "lng":77.624045
            },
            "ts":1620906507
         },
         {
            "latlng":{
               "lat":12.937731,
               "lng":77.624045
            },
            "ts":1620906512
         },
         {
            "latlng":{
               "lat":12.93849,
               "lng":77.623379
            },
            "ts":1620906521
         },
         {
            "latlng":{
               "lat":12.938861,
               "lng":77.623045
            },
            "ts":1620906527
         },
         {
            "latlng":{
               "lat":12.939278,
               "lng":77.62267
            },
            "ts":1620906533
         },
         {
            "latlng":{
               "lat":12.939638,
               "lng":77.622222
            },
            "ts":1620906542
         },
         {
            "latlng":{
               "lat":12.939638,
               "lng":77.622222
            },
            "ts":1620906553
         },
         {
            "latlng":{
               "lat":12.938979,
               "lng":77.621582
            },
            "ts":1620906559
         },
         {
            "latlng":{
               "lat":12.938396,
               "lng":77.621216
            },
            "ts":1620906564
         },
         {
            "latlng":{
               "lat":12.937858,
               "lng":77.620926
            },
            "ts":1620906570
         },
         {
            "latlng":{
               "lat":12.937858,
               "lng":77.620926
            },
            "ts":1620906575
         },
         {
            "latlng":{
               "lat":12.937151,
               "lng":77.620546
            },
            "ts":1620906580
         },
         {
            "latlng":{
               "lat":12.937151,
               "lng":77.620546
            },
            "ts":1620906586
         },
         {
            "latlng":{
               "lat":12.936733,
               "lng":77.62032
            },
            "ts":1620906592
         },
         {
            "latlng":{
               "lat":12.93652,
               "lng":77.619895
            },
            "ts":1620906598
         },
         {
            "latlng":{
               "lat":12.936874,
               "lng":77.619281
            },
            "ts":1620906604
         },
         {
            "latlng":{
               "lat":12.937714,
               "lng":77.618663
            },
            "ts":1620906615
         },
         {
            "latlng":{
               "lat":12.937714,
               "lng":77.618663
            },
            "ts":1620906624
         },
         {
            "latlng":{
               "lat":12.936546,
               "lng":77.617936
            },
            "ts":1620906634
         },
         {
            "latlng":{
               "lat":12.936299,
               "lng":77.61748
            },
            "ts":1620906639
         },
         {
            "latlng":{
               "lat":12.936299,
               "lng":77.61748
            },
            "ts":1620906644
         },
         {
            "latlng":{
               "lat":12.936218,
               "lng":77.616142
            },
            "ts":1620906654
         },
         {
            "latlng":{
               "lat":12.936026,
               "lng":77.615635
            },
            "ts":1620906659
         },
         {
            "latlng":{
               "lat":12.936044,
               "lng":77.614688
            },
            "ts":1620906670
         },
         {
            "latlng":{
               "lat":12.935669,
               "lng":77.613955
            },
            "ts":1620906679
         },
         {
            "latlng":{
               "lat":12.935338,
               "lng":77.613308
            },
            "ts":1620906689
         },
         {
            "latlng":{
               "lat":12.935338,
               "lng":77.613308
            },
            "ts":1620906705
         },
         {
            "latlng":{
               "lat":12.935092,
               "lng":77.612909
            },
            "ts":1620906718
         },
         {
            "latlng":{
               "lat":12.935092,
               "lng":77.612909
            },
            "ts":1620906728
         },
         {
            "latlng":{
               "lat":12.934976,
               "lng":77.613362
            },
            "ts":1620906734
         },
         {
            "latlng":{
               "lat":12.934976,
               "lng":77.613362
            },
            "ts":1620906817
         },
         {
            "latlng":{
               "lat":12.935432,
               "lng":77.613492
            },
            "ts":1620906822
         },
         {
            "latlng":{
               "lat":12.935432,
               "lng":77.613492
            },
            "ts":1620906955
         },
         {
            "latlng":{
               "lat":12.93514,
               "lng":77.612933
            },
            "ts":1620906960
         },
         {
            "latlng":{
               "lat":12.93514,
               "lng":77.612933
            },
            "ts":1620907085
         },
         {
            "latlng":{
               "lat":12.934983,
               "lng":77.613376
            },
            "ts":1620907091
         },
         {
            "latlng":{
               "lat":12.934983,
               "lng":77.613376
            },
            "ts":1620907167
         },
         {
            "latlng":{
               "lat":12.93229,
               "lng":77.613649
            },
            "ts":1620907205
         },
         {
            "latlng":{
               "lat":12.931773,
               "lng":77.613907
            },
            "ts":1620907211
         },
         {
            "latlng":{
               "lat":12.931341,
               "lng":77.614045
            },
            "ts":1620907216
         },
         {
            "latlng":{
               "lat":12.930906,
               "lng":77.6143
            },
            "ts":1620907221
         },
         {
            "latlng":{
               "lat":12.930496,
               "lng":77.614549
            },
            "ts":1620907226
         },
         {
            "latlng":{
               "lat":12.930104,
               "lng":77.614801
            },
            "ts":1620907231
         },
         {
            "latlng":{
               "lat":12.930104,
               "lng":77.614801
            },
            "ts":1620907237
         },
         {
            "latlng":{
               "lat":12.929613,
               "lng":77.615569
            },
            "ts":1620907242
         },
         {
            "latlng":{
               "lat":12.929426,
               "lng":77.616064
            },
            "ts":1620907247
         },
         {
            "latlng":{
               "lat":12.929197,
               "lng":77.616675
            },
            "ts":1620907253
         },
         {
            "latlng":{
               "lat":12.92898,
               "lng":77.617245
            },
            "ts":1620907259
         },
         {
            "latlng":{
               "lat":12.928802,
               "lng":77.617718
            },
            "ts":1620907264
         },
         {
            "latlng":{
               "lat":12.928613,
               "lng":77.618224
            },
            "ts":1620907269
         },
         {
            "latlng":{
               "lat":12.9284,
               "lng":77.618792
            },
            "ts":1620907275
         },
         {
            "latlng":{
               "lat":12.928285,
               "lng":77.619333
            },
            "ts":1620907280
         },
         {
            "latlng":{
               "lat":12.928038,
               "lng":77.619761
            },
            "ts":1620907285
         },
         {
            "latlng":{
               "lat":12.927828,
               "lng":77.620323
            },
            "ts":1620907291
         },
         {
            "latlng":{
               "lat":12.927631,
               "lng":77.620851
            },
            "ts":1620907296
         },
         {
            "latlng":{
               "lat":12.927631,
               "lng":77.620851
            },
            "ts":1620907301
         },
         {
            "latlng":{
               "lat":12.927285,
               "lng":77.621676
            },
            "ts":1620907308
         },
         {
            "latlng":{
               "lat":12.927290000000001,
               "lng":77.62168000000001
            },
            "ts":1620907315
         },
         {
            "latlng":{
               "lat":12.926990000000002,
               "lng":77.62234000000001
            },
            "ts":1620907321
         },
         {
            "latlng":{
               "lat":12.926540000000001,
               "lng":77.62336
            },
            "ts":1620907327
         },
         {
            "latlng":{
               "lat":12.92581,
               "lng":77.62517000000001
            },
            "ts":1620907334
         },
         {
            "latlng":{
               "lat":12.9258,
               "lng":77.62519
            },
            "ts":1620907340
         },
         {
            "latlng":{
               "lat":12.92523,
               "lng":77.62656000000001
            },
            "ts":1620907346
         },
         {
            "latlng":{
               "lat":12.925110000000002,
               "lng":77.62685
            },
            "ts":1620907353
         },
         {
            "latlng":{
               "lat":12.92453,
               "lng":77.62827
            },
            "ts":1620907359
         },
         {
            "latlng":{
               "lat":12.924240000000001,
               "lng":77.62891
            },
            "ts":1620907365
         },
         {
            "latlng":{
               "lat":12.9242,
               "lng":77.62903
            },
            "ts":1620907372
         },
         {
            "latlng":{
               "lat":12.924190000000001,
               "lng":77.62957
            },
            "ts":1620907378
         },
         {
            "latlng":{
               "lat":12.9244,
               "lng":77.63084
            },
            "ts":1620907384
         },
         {
            "latlng":{
               "lat":12.924510000000001,
               "lng":77.63137
            },
            "ts":1620907391
         },
         {
            "latlng":{
               "lat":12.924550000000002,
               "lng":77.63164
            },
            "ts":1620907397
         },
         {
            "latlng":{
               "lat":12.92487,
               "lng":77.63353000000001
            },
            "ts":1620907403
         },
         {
            "latlng":{
               "lat":12.924880000000002,
               "lng":77.63356
            },
            "ts":1620907410
         },
         {
            "latlng":{
               "lat":12.924890000000001,
               "lng":77.63366
            },
            "ts":1620907416
         },
         {
            "latlng":{
               "lat":12.92495,
               "lng":77.63404000000001
            },
            "ts":1620907422
         },
         {
            "latlng":{
               "lat":12.92515,
               "lng":77.63533000000001
            },
            "ts":1620907429
         },
         {
            "latlng":{
               "lat":12.925300000000002,
               "lng":77.63637
            },
            "ts":1620907435
         },
         {
            "latlng":{
               "lat":12.92534,
               "lng":77.63669
            },
            "ts":1620907441
         },
         {
            "latlng":{
               "lat":12.925310000000001,
               "lng":77.63698000000001
            },
            "ts":1620907448
         },
         {
            "latlng":{
               "lat":12.92515,
               "lng":77.63743000000001
            },
            "ts":1620907454
         },
         {
            "latlng":{
               "lat":12.924980000000001,
               "lng":77.63773
            },
            "ts":1620907460
         },
         {
            "latlng":{
               "lat":12.92481,
               "lng":77.63802000000001
            },
            "ts":1620907467
         },
         {
            "latlng":{
               "lat":12.92459,
               "lng":77.63837000000001
            },
            "ts":1620907473
         },
         {
            "latlng":{
               "lat":12.924430000000001,
               "lng":77.63861
            },
            "ts":1620907479
         },
         {
            "latlng":{
               "lat":12.9243,
               "lng":77.63895000000001
            },
            "ts":1620907486
         },
         {
            "latlng":{
               "lat":12.9243,
               "lng":77.63895000000001
            },
            "ts":1620907492
         },
         {
            "latlng":{
               "lat":12.924298,
               "lng":77.638948
            },
            "ts":1620907498
         },
         {
            "latlng":{
               "lat":12.924066,
               "lng":77.639557
            },
            "ts":1620907504
         },
         {
            "latlng":{
               "lat":12.923424,
               "lng":77.639819
            },
            "ts":1620907513
         },
         {
            "latlng":{
               "lat":12.923420000000002,
               "lng":77.63982
            },
            "ts":1620907519
         },
         {
            "latlng":{
               "lat":12.922600000000001,
               "lng":77.63943
            },
            "ts":1620907525
         },
         {
            "latlng":{
               "lat":12.921600000000002,
               "lng":77.6389
            },
            "ts":1620907530
         },
         {
            "latlng":{
               "lat":12.92101,
               "lng":77.63871
            },
            "ts":1620907536
         },
         {
            "latlng":{
               "lat":12.920480000000001,
               "lng":77.63855000000001
            },
            "ts":1620907541
         },
         {
            "latlng":{
               "lat":12.919830000000001,
               "lng":77.63843
            },
            "ts":1620907547
         },
         {
            "latlng":{
               "lat":12.919400000000001,
               "lng":77.63839
            },
            "ts":1620907553
         },
         {
            "latlng":{
               "lat":12.91796,
               "lng":77.63833000000001
            },
            "ts":1620907558
         },
         {
            "latlng":{
               "lat":12.91614,
               "lng":77.63826
            },
            "ts":1620907564
         },
         {
            "latlng":{
               "lat":12.916100000000002,
               "lng":77.63826
            },
            "ts":1620907569
         },
         {
            "latlng":{
               "lat":12.915970000000002,
               "lng":77.63825
            },
            "ts":1620907575
         },
         {
            "latlng":{
               "lat":12.915920000000002,
               "lng":77.63825
            },
            "ts":1620907581
         },
         {
            "latlng":{
               "lat":12.91586,
               "lng":77.63825
            },
            "ts":1620907586
         },
         {
            "latlng":{
               "lat":12.91586,
               "lng":77.63825
            },
            "ts":1620907592
         },
         {
            "latlng":{
               "lat":12.915855,
               "lng":77.638249
            },
            "ts":1620907597
         },
         {
            "latlng":{
               "lat":12.91586,
               "lng":77.63825
            },
            "ts":1620907602
         },
         {
            "latlng":{
               "lat":12.91577,
               "lng":77.63825
            },
            "ts":1620907607
         },
         {
            "latlng":{
               "lat":12.915540000000002,
               "lng":77.63824000000001
            },
            "ts":1620907612
         },
         {
            "latlng":{
               "lat":12.915120000000002,
               "lng":77.63822
            },
            "ts":1620907617
         },
         {
            "latlng":{
               "lat":12.914610000000001,
               "lng":77.63820000000001
            },
            "ts":1620907622
         },
         {
            "latlng":{
               "lat":12.91449,
               "lng":77.63814
            },
            "ts":1620907627
         },
         {
            "latlng":{
               "lat":12.91394,
               "lng":77.63813
            },
            "ts":1620907632
         },
         {
            "latlng":{
               "lat":12.913030000000001,
               "lng":77.63810000000001
            },
            "ts":1620907637
         },
         {
            "latlng":{
               "lat":12.912880000000001,
               "lng":77.63811000000001
            },
            "ts":1620907642
         },
         {
            "latlng":{
               "lat":12.912370000000001,
               "lng":77.63810000000001
            },
            "ts":1620907647
         },
         {
            "latlng":{
               "lat":12.912320000000001,
               "lng":77.63810000000001
            },
            "ts":1620907652
         },
         {
            "latlng":{
               "lat":12.912210000000002,
               "lng":77.63809
            },
            "ts":1620907657
         },
         {
            "latlng":{
               "lat":12.912080000000001,
               "lng":77.63809
            },
            "ts":1620907662
         },
         {
            "latlng":{
               "lat":12.912080000000001,
               "lng":77.63809
            },
            "ts":1620907667
         },
         {
            "latlng":{
               "lat":12.91205,
               "lng":77.63911
            },
            "ts":1620907671
         },
         {
            "latlng":{
               "lat":12.91205,
               "lng":77.63911
            },
            "ts":1620907676
         },
         {
            "latlng":{
               "lat":12.912053,
               "lng":77.639108
            },
            "ts":1620907681
         },
         {
            "latlng":{
               "lat":12.912053,
               "lng":77.639108
            },
            "ts":1620907702
         }
      ],
      "order_status":"Completed"
   };

function fetchOrderMapData(_order_id, param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyResponseSample
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderDetailsMapRepoConfig.OrderDetailsMapResponseConverter.execute, result);
                        });
            });
}

var OrderDetailsMapRepo = {
  dummyResponseSample: dummyResponseSample,
  dummyResponseSampleNew: dummyResponseSampleNew,
  dummyResponseSample2: dummyResponseSample2,
  dummyResponseSample3: dummyResponseSample3,
  dummyResponseSample4: dummyResponseSample4,
  dummyResponseSample5: dummyResponseSample5,
  dummyResponseSample6: dummyResponseSample6,
  fetchOrderMapData: fetchOrderMapData
};

export {
  OrderDetailsMapRepo ,
  
}
/* OrderDetailsMapRepoConfig Not a pure module */
